import Moment from "moment";
import { mapActions } from "vuex";
import { getStayLength } from "../utilMixin";

export default {
  data() {
    return {
      isReqStatus: false, // 房态请求防抖
      // 字典列表
      dictList: {
        rooms: [],
        roomType: [],
        platform: [],
        orderType: [
          { code: 1, name: "全日房" },
          { code: 2, name: "钟点房" },
        ],
      },
      // 房态状态列表
      statusList: [
        { id: "1", value: 1, prop: "room", label: "空房", name: "empty" },
        { id: "2", value: 1, prop: "order", label: "已预订", name: "order" },
        { id: "3", value: 2, prop: "order", label: "已登记", name: "register" },
        { id: "4", value: 3, prop: "order", label: "已入住", name: "stay" },
        { id: "5", value: 4, prop: "order", label: "已完成", name: "finish" },
        { id: "6", value: 2, prop: "room", label: "脏房", name: "dirty" },
      ],
    };
  },
  computed: {
    // 获取今日 value
    todayValue() {
      let today = Moment(new Date()).format("YYYY-MM-DD");
      return +new Date(today);
    },
    // 获取当前单元格class，将会更改的class内容放到computed，减少消耗
    getCurCellClass() {
      let curCell = this.curSelCell;
      const func = (order, room) => {
        return order.dateVal === curCell.dateVal &&
          room.id === curCell.parentProps.roomId
          ? "cur-active"
          : "";
      };

      return func;
    },
    // 判断是否当前悬停/选中单元格
    isCurHoverCell() {
      let curCell = this.curSelCell;
      let hoverCell = this.curHoverCell;
      const func = (order, room) => {
        let res =
          (order.dateVal === curCell.dateVal &&
            room.id === curCell.parentProps.roomId) ||
          (order.dateVal === hoverCell.dateVal &&
            room.id === hoverCell.parentProps.roomId);
        return res;
      };
      return func;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$eventBus.off("change-shop");
    next();
  },
  created() {
    this.getDictData();

    this.selDate = Moment(new Date()).format("YYYY-MM-DD");

    let curStore = localStorage.getItem("curShop");
    if (!curStore || curStore === "undefined" || curStore === "null") {
      this.curStore = {};
      this.storeId = "";
      this.$confirm("请先添加门店", {
        type: "warning",
      }).then(() => {
        this.$router.push("/shop/shopManage");
      });
      return;
    } else {
      this.curStore = JSON.parse(curStore);
      this.storeId = this.curStore.id;
    }

    this.$eventBus.on("change-shop", (store) => {
      this.$nextTick(() => {
        this.storeId = store.id;
        this.curStore = store || {};
        this.getStatusList();
        this.getDictData();
      });
    });
    this.initDateList();
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 获取当前门店信息
    getCurStoreInfo() {
      let curShopInfo = {};
      let localShop = localStorage.getItem("curShop");
      if (
        localShop &&
        localShop !== undefined &&
        localShop !== "undefined" &&
        typeof localShop === "string"
      ) {
        curShopInfo = JSON.parse(localShop);
      }
      return curShopInfo;
    },
    // 获取字典数据
    getDictData() {
      let url = "";
      //房源
      let params = { reviewStatus: 2, pageNumber: 1, pageSize: 99999999 };
      let curStoreInfo = this.getCurStoreInfo();
      if (curStoreInfo && curStoreInfo.id) {
        params.storeId = curStoreInfo.id;
      }
      this.fetchData({ url: "SAAS.ROOM_LIST", method: "get", params }).then(
        (res) => {
          res = res || {};
          res.data = res.data || [];
          let rooms = [];
          res.data.map((obj) => {
            rooms.push({
              id: obj.id,
              roomName: obj.roomName,
              roomCode: obj.roomCode,
              roomTypeId: obj.roomTypeId,
            });
          });
          this.dictList.rooms = rooms;
        }
      );

      // 房型
      params = { pageNumber: 1, pageSize: 99999999, storeId: params.storeId };
      url = "SAAS.ROOM_TYPE_LIST";
      this.fetchData({ url, method: "get", params }).then((res) => {
        this.dictList.roomType = res.data || [];
      });

      // 平台
      url = "SAAS.ROOM_PLATEFORM";
      this.fetchData({ url, method: "get" }).then((res) => {
        this.dictList.platform = res.data || [];
      });

      //证件类型
      url = "RESOURCE.QUERY_DICTS_LIST";
      this.fetchData({
        url,
        method: "get",
        params: {
          types: "certType",
        },
        flag: true,
      })
        .then((res) => {
          if (!res || res.code != 200) {
            return false;
          }
          this.dictList.certType = res.data.certType || [];
        })
    },
    // 初始化日期列表
    initDateList() {
      // { date: '04.15', fullDate: '2022-04-15', week: '一', roomCount: 1, dateVal: +new Date('2022-04-15') }

      let weekList = ["日", "一", "二", "三", "四", "五", "六"];
      let nowDate = +new Date(this.selDate);
      let dateList = [];
      for (let i = -1; i < 29; i++) {
        let date = new Date(nowDate + i * 24 * 60 * 60 * 1000);
        dateList.push({
          date: Moment(date).format("MM.DD"),
          fullDate: Moment(date).format("YYYY-MM-DD"),
          week: weekList[new Date(date).getDay()],
          roomCount: 0,
          dateVal: +date,
        });
      }

      this.dateList = dateList;

      this.getStatusList();
    },
    // 获取房态列表
    getStatusList() {
      if (this.isReqStatus) return;

      let url = "ROOM.STATUS.POST_QUERY";

      if (this.selRoomTypeList && this.selRoomTypeList.length) {
        let params = this.selRoomTypeList
          .map((item) => `roomTypeIdList=${item}`)
          .join("&");
        url = "/api/web/roomInfo/queryRoomStatus?" + params;
      }

      let date = +new Date(this.selDate);
      let params = {
        queryTimeStart:
          Moment(new Date(date - 24 * 60 * 60 * 1000)).format("YYYY-MM-DD") +
          " 00:00:00",
        queryTimeEnd:
          Moment(new Date(date + 28 * 24 * 60 * 60 * 1000)).format(
            "YYYY-MM-DD"
          ) + " 23:59:59",
        // roomTypeId: "",
        storeId: this.curStore.id,
      };
      this.isReqStatus = true;
      this.fetchData({
        url,
        method: "post",
        params,
        headers: { "Content-Type": "application/json" }
      })
        .then((res) => {
          if (res.status === 1) {
            res = res.data || [];
            let list = [];
            res.forEach((item) => {
              let arr = item.roomAndOrderList || [];
              let skip = 0;
              arr = arr.filter((item) => item.reviewStatus != 4); // 去除已注销

              arr.forEach((room) => {
                room.id = room.roomId;
                room.skip = skip++;
              });
              list.push(...arr);
            });

            this.buildOrderList(list);
            this.buildDateRoomCount(list);
            this.roomStatusList = list;
          }
        })
        .catch((err) => {
          this.$message.error(err || "获取数据失败！");
        })
        .finally(() => {
          this.isReqStatus = false;
        });
    },
    // 构建订单列表
    buildOrderList(list) {
      // { id: '7', bookerName: '', orderSourceName: '', stayCount: '', bookerPhone: '', orderType: '', status: 'empty', statusName: '空房' },
      // { id: '1', dateVal: +new Date('2022-04-15'), bookerName: '张三1', orderSourceName: '美团', stayCount: '3晚', bookerPhone: '13145671230', orderType: 1, status: 'stay', statusName: '入住中', skip: 0 }
      list.forEach((room) => {
        room.orderList = room.orderList || [];
        let skip = 0;
        if(!room.orderList.length) room.orderList = this.dateList.map(e => null);
        for (let i = 0; i < room.orderList.length; i++) {
          let order = room.orderList[i] || {};
          let date = this.dateList[i];

          order.dateVal = date.dateVal;
          order.fullDate = date.fullDate;

          // 仅在有订单的情况下追加属性
          if (order.orderCode) {
            order.skip = skip++;
            // 订单是否到今日为止
            if (
              !room.orderList[i + 1] ||
              (room.orderList[i + 1] &&
                room.orderList[i + 1].orderCode !== order.orderCode)
            ) {
              order.isFinal = true;
              skip = 0;
            }

            let stayCount = getStayLength(
              order.proposedCheckInTime,
              order.proposedCheckOutTime,
              order.orderType
            );
            order.stayCount = stayCount + "小时";
            if (order.orderType === 1) {
              order.stayCount = stayCount + "晚";
            }
          }
          let status = this.getStatus(order, room);
          order.status = status.name;
          order.statusName = status.label;

          // 将父信息放到订单中，方便获取使用
          let tempRoom = JSON.parse(JSON.stringify(room));
          delete tempRoom.orderList;
          order.parentProps = tempRoom;

          room.orderList[i] = order;
        }
      });
    },
    // 获取房源状态，最优先订单状态，然后是今日脏房状态，除此之外的都是空房
    getStatus(order, room) {
      if (order.orderState) {
        let status = this.statusList.filter((item) => {
          return item.prop === "order" && item.value === order.orderState;
        })[0];

        return status || {};
      }

      // if (order.dateVal === this.todayValue && room.cleanStatus === 2) {
      //   let status = this.statusList.filter((item) => {
      //     return item.prop === "room" && item.value === 2;
      //   })[0];

      //   return status;
      // }

      let status = this.statusList.filter((item) => {
        return item.prop === "room" && item.value === 1;
      })[0];

      return status;
    },
    // 构建日期头部的剩余房源数量
    buildDateRoomCount(list) {
      this.dateList.forEach((item, index) => {
        let count = 0;
        list.forEach((room) => {
          let order = room.orderList[index];
          if (order.status === "empty" || order.status === "dirty") count++;
        });
        item.roomCount = count;
      });
    },
    // 处理日期切换
    handleChangeDate(type) {
      let date = +new Date(this.selDate);
      switch (type) {
        case "forward":
          date = date - 24 * 60 * 60 * 1000;
          break;
        case "backward":
          date = date + 24 * 60 * 60 * 1000;
          break;
      }
      this.selDate = Moment(new Date(date)).format("YYYY-MM-DD");
      this.initDateList();
    },
    // 获取单元格class
    getCellClass(order, room) {
      let cellClass = [];

      // 单元格类型
      if (order.skip === 0 && !order.isFinal) {
        cellClass.push("card-head");
      } else if (order.skip > 0 && !order.isFinal) {
        cellClass.push("card-body");
      } else if (order.skip > 0 && order.isFinal) {
        cellClass.push("card-foot");
      } else {
        cellClass.push("card-full");
      }

      // 是否空房单元格
      if (order.status === "empty") {
        cellClass.push("room-empty");
      }

      // 是否今日单元格
      if (order.dateVal === this.todayValue) {
        cellClass.push("cell-today");
      }

      return cellClass.join(" ");
    },
    // 行修改、行取消、行退房
    handleRowEdit(row, modalType) {
      this.modalType = modalType;
      if (modalType === "checkout") {
        this.orderDetail = { ...row };
        this.$nextTick(() => {
          this.fixModal = true;
        });
      } else if (modalType === "cancel") {
        this.$confirm("该操作是不可恢复的，是否取消订单!", {
          type: "warning",
        }).then(() => {
          this.reqCancelOrder(row);
        });
      } else if (modalType === "edit" || modalType === "show") {
        this.getOrderDetailInfo((res) => {
          this.orderDetail = { ...res.data } || [];
          this.$nextTick(() => {
            this.fixModal = true;
          });
        });
      }
    },
    // 执行取消订单
    reqCancelOrder(row) {
      let url = "SAAS.ORDER_EDIT_CANCEL";
      let params = { id: row.id };

      this.fetchData({ url, method: "post", params, flag: true })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg || "操作成功！");
            this.handleModalSuccess();
          } else {
            this.$message.error(res.msg || "操作失败！");
          }
        })
        .catch((err) => {
          this.$message.error(err || "操作失败！");
        });
    },
    // 更改房源信息
    changeRoomInfo(params) {
      let url = "ROOM.POST_CHANGE_CLEAN_STATUS";
      params.id = params.id || this.curSelCell.parentProps.roomId;

      this.fetchData({
        url,
        method: "post",
        params,
        flag: true,
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功！");
          this.getStatusList();
        } else {
          this.$message.error(res.msg || "操作失败！");
        }
      });
    },
    // 判断是否需要显示订单信息
    getIsShowOrderDetail(order) {
      if (order.status === "empty" || order.status === "dirty") {
        return false;
      }
      return order.skip === 0;
    },
    // 根据房态获取对应的操作按钮组
    getOperBtnGroup(order) {
      if (order.status === "empty") {
        return [
          { type: "addOrder", label: "录入订单" },
          // { type: "setDirty", label: "置脏" },
          // { type: "clean", label: "保洁" },
        ];
      }
      if (order.status === "order" || order.status === "register") {
        let list = [
          { type: "orderDetail", label: "查看订单" },
          { type: "changeRoom", label: "换房" },
          { type: "earlyStay", label: "提前入住" },
          { type: "cancelOrder", label: "取消订单" },
          // { type: "clean", label: "保洁" },
        ]
        if (order.orderType == 2) {
          list.splice(2, 1)
        }
        return list;
      }
      if (order.status === "stay") {
        return [
          { type: "orderDetail", label: "查看订单" },
          { type: "changeRoom", label: "换房" },
          { type: "checkout", label: "退房" },
          { type: "continueStay", label: "续住" },
          // { type: "clean", label: "保洁" },
        ];
      }
      if (order.status === "finish") {
        return [
          { type: "orderDetail", label: "查看订单" },
          { type: "reserveAgain", label: "再次预定" },
          // { type: "clean", label: "保洁" },
        ];
      }
      if (order.status === "dirty") {
        return [
          // { type: "setEmpty", label: "置“净”" },
          // { type: "clean", label: "保洁" },
        ];
      }
    },
  },
};
